import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  DialogActions,
  Button,
  Box,
  IconButton,
  Divider
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

export default function ViewServiceModal({ open, onClose, data }) {
  if (!data) return null;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle
        sx={{
          bgcolor: '#3F90DF',
          color: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        Service Details
        <IconButton onClick={onClose} sx={{ color: '#fff' }}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: '#161C24', color: '#fff', py: 4 }}>
        <Grid container spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="caption" color="grey.500">
              COMPANY NAME
            </Typography>
            <Typography variant="h6">{data.company_name}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="caption" color="grey.500">
              EMAIL ADDRESS
            </Typography>
            <Typography variant="h6">{data.email_address}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="caption" color="grey.500">
              JOINED DATE
            </Typography>
            <Typography variant="h6">{data.joined_date}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="caption" color="grey.500">
              ACCOUNT TYPE
            </Typography>
            <Typography variant="h6">{data.account_type}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ bgcolor: '#161C24', p: 3, borderTop: '1px solid #333' }}>
        <Button onClick={onClose} variant="outlined" sx={{ color: '#fff', borderColor: '#333' }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
